var lp = './img/';
var plp = '//placehold.it/350x250/';

const state = {
  images : [
    lp+'team1.jpg', lp+'team2.jpg', lp+'team3.jpg', plp+'78c5d6/fff/image1.jpg', plp+'459ba8/fff/image2.jpg', plp+'79c267/fff/image3.jpg',
    plp+'c5d647/fff/image4.jpg', plp+'f28c33/fff/image5.jpg', plp+'e868a2/fff/image6.jpg', plp+'cc4360/fff/image7.jpg',
    lp+'work-desk.jpg', lp+'phone-app.png', lp+'bg-gr-v.png'
  ]
};
const mutations = {
  setImages (state,images) {
    state.images = images;
  },
  setImageByIndex (state,data) {
    state.dispositions[data.index] = data.image;
  }
};
const actions = {
  setImages: ({ state, commit }, images) => commit('setImages', images),
  setImageByIndex: ({ state, commit }, data) => commit('setImageByIndex', data),
};
const getters = {
  getImages: state => state.images
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/images-data.js